import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type FAQItem = {
  question: string;
  answer: string;
};
const faqItems: FAQItem[] = [{
  question: '¿Necesito experiencia previa?',
  answer: 'No. Tenemos grupos por nivel y te guiamos desde cero. Muchos de nuestros alumnos empezaron sin haber dado un golpe en su vida.'
}, {
  question: '¿Qué necesito llevar?',
  answer: 'Ropa cómoda, agua y toalla. Guantes y vendas si ya los tienes; si no, te orientamos sobre qué comprar y mientras tanto te prestamos material.'
}, {
  question: '¿Puedo venir si mi objetivo es perder peso?',
  answer: 'Sí. Ajustamos la intensidad a tu nivel y te damos la guía de nutrición base para acelerar resultados. El entrenamiento de artes marciales es uno de los más efectivos para quemar grasa.'
}, {
  question: '¿Hay sparring?',
  answer: 'Solo si aplica y cuando estés listo. Primero trabajamos técnica y control. El sparring es una herramienta de aprendizaje, no un combate. Nadie te va a tirar al ring sin estar preparado.'
}, {
  question: '¿Cómo reservo mi clase?',
  answer: 'En el botón de Calendly eliges día y hora, y listo. En menos de 30 segundos tienes tu plaza confirmada.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="w-full bg-[#0a0a0a] py-20 px-4 sm:px-6 lg:px-8" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-60">
          <h2 className="font-heading font-bold text-white uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight" data-id="element-61">
            Preguntas frecuentes
          </h2>
          <div className="section-divider" data-id="element-62" />
        </div>

        {/* Accordion */}
        <div className="space-y-2" data-id="element-63">
          {faqItems.map((item, index) => <div key={index} className="bg-[#1a1a1a] border border-[#2a2a2a] overflow-hidden" data-id="element-64">
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between px-6 py-5 text-left group" aria-expanded={openIndex === index} data-id="element-65">
                <span className="font-heading font-bold text-[#C9A84C] uppercase tracking-wide text-base pr-4 group-hover:text-[#E8C97A] transition-colors duration-200" data-id="element-66">
                  {item.question}
                </span>
                <ChevronDownIcon size={20} className={`text-[#C9A84C] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-67" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-68">
                <div className="px-6 pb-5 border-t border-[#2a2a2a]" data-id="element-69">
                  <p className="font-body text-gray-300 text-sm leading-relaxed pt-4" data-id="element-70">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}